import React, { useEffect, useRef, useCallback } from 'react';
import AntSearchPieChart from './AntSearchPieChart';
import AntToolbar from './AntToolbar';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default function (props) {
    var [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url || props.table || props.loadFunc));

    var handleLoaded = useCallback((dataRows) => {
        if (props.onEmpty) {
            var rows = dataRows && dataRows.data instanceof Array ? dataRows.data : [];
            props.onEmpty(rows.length === 0);
        }
        markLoaded();
    }, [markLoaded]);
    let storageKey = props.storageKey
        ? props.storageKey
        : 'widget-pie-chart-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    const chart = useRef();

    useEffect(() => {
        var ms = ((props.refreshIntervalSec ?? 0) | 0) * 1000;
        if (ms <= 0) return;
        var iv = setInterval(function () {
            try { if (chart.current && chart.current.refresh) chart.current.refresh(); } catch (e) {}
        }, ms);
        return () => clearInterval(iv);
    }, [props.refreshIntervalSec]);

    return (
        <React.Fragment>
            {props.showTitle !== false && (
                <AntToolbar
                    title={props.title ? props.title : props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    showHelp={props.showHelp}
                    isH6={true}
                    upperCase={true}
                    // upperCase={props.upperCase}
                />
            )}

            <div className="ant-widget-skeleton-host">
                    {!loaded && <AntWidgetSkeleton variant="doughnut" overlay={true} height={props.height} />}
                    <AntSearchPieChart
                    ref={chart}
                    API={props.API}
                    url={props.url}
                    table={props.table}
                    showActionBar={false}
                    entityName={props.entityName}
                    entityDisplay={props.entityDisplay}
                    storageKey={storageKey}
                    isSearching={true}
                    searchConditions={props.searchConditions}
                    searchFields={props.searchFields}
                    hideHeaderMargin={true}
                    actionItems={props.actionItems}
                    showSearchBar={props.showSearchBar}
                    locationSearchBar={props.locationSearchBar}
                    argumentField={props.argumentField}
                    argumentFormat={props.argumentFormat}
                    queryFields={props.queryFields}
                    series1={props.series1}
                    series2={props.series2}
                    series3={props.series3}
                    valueAxis={props.valueAxis}
                    legend={props.legend}
                    height={props.height}
                    width={props.width}
                    onLoaded={handleLoaded}
                    />
            </div>
        </React.Fragment>
    );
}
